import { useMemo } from 'react';
import { Control, useWatch } from 'react-hook-form';
import { ZodObject, ZodRawShape } from 'zod';

export const useSafeParseFormField = (
  control: Control,
  fieldName: string,
  validationSchema: ZodObject<ZodRawShape>
): boolean => {
  const watchedFields = useWatch({ control, name: fieldName });

  return useMemo(() => {
    const schema = validationSchema.pick({
      [fieldName]: true,
    });

    const result = schema.safeParse({ [fieldName]: watchedFields });

    return result.success;
  }, [watchedFields, validationSchema, fieldName]);
};
